import React from "react";
import Collapsable from "../../collapsable/containers/CollapsableContainer";
import Tag from "./Tag";
import Button from "./ButtonFilter";

const tiempo = () => {
  const now = new Date();
  const content = [];
  for (let i = 2020; i <= now.getFullYear(); i++) {
    content.push({ title: i.toString(), id: i });
  }
  return [
    {
      group: "Año",
      variable: "year",
      content,
    },
    {
      group: "Mes",
      variable: "month",
      content: [
        { title: "Enero", id: 1 },
        { title: "Febrero", id: 2 },
        { title: "Marzo", id: 3 },
        { title: "Abril", id: 4 },
        { title: "Mayo", id: 5 },
        { title: "Junio", id: 6 },
        { title: "Julio", id: 7 },
        { title: "Agosto", id: 8 },
        { title: "Septiembre", id: 9 },
        { title: "Octubre", id: 10 },
        { title: "Noviembre", id: 11 },
        { title: "Diciembre", id: 12 },
      ],
    },
    // {
    //   group: 'Semestre',
    //   variable: 'semester',
    //   content: [
    //     { title: 'Enero - Junio', id: 1 },
    //     { title: 'Julio - Diciembre', id: 2 },
    //   ]
    // },
  ];
};

const selectChange = (props, feno, ev) => {
  const data = feno.content
    .filter((i) => i.id === parseInt(ev.target.value))
    .reduce((pre, cur) => cur, {});
  props.buttonHandler({ ...data, variable: feno.variable }, "filter");
};

const getContent = (content, props, filterType = "filter") => {
  return (
    <>
      {content.map((feno, i0) => {
        const prevar = props.state[filterType];
        return (
          <React.Fragment key={`content-key-${i0}`}>
            <div className="title-button-group-f ContCardFenomene">
              {feno.group}
            </div>
            <div className="ContCardFenomene button-container">
              {feno.content.length <= 12 ? (
                feno.content.map((fen, i) => (
                  <Button
                    key={`filter-button-${feno.group.split(" ")[0]}-key-${i}`}
                    prevar={prevar}
                    feno={feno}
                    filterType={filterType}
                    fen={fen}
                    buttonHandler={props.buttonHandler}
                  />
                ))
              ) : (
                <select
                  onChange={(e) => selectChange(props, feno, e)}
                  className="line-selects"
                >
                  <option disabled defaultValue={true}>
                    Selecciona una opción
                  </option>
                  {feno.content.map((fen, i) => (
                    <option
                      value={fen.id}
                      key={`select-option-key-${feno.variable}-${fen.id}`}
                    >
                      {fen.title}
                    </option>
                  ))}
                </select>
              )}
            </div>
            <hr />
          </React.Fragment>
        );
      })}
    </>
  );
};

const getTags = (array, props, filterType = "filter") => {
  const result = getTagsArray(array, props, filterType);
  return (
    <>
      {result.map((item, index) => {
        return (
          <Tag
            key={`tag-filter-${item.variable}-key-${index}`}
            buttonHandler={props.buttonHandler}
            item={item}
            filterType={filterType}
          />
        );
      })}
    </>
  );
};

const getTagsArray = (content, props, filterType) => {
  let resp = [];
  const prevar = props.state[filterType];
  content
    .filter((con) => prevar[con.variable].length)
    .forEach((con) => {
      prevar[con.variable].forEach((element) => {
        con.content
          .filter((cont) => cont.id === element)
          .forEach((it) => {
            resp.push({ title: it.title, id: it.id, variable: con.variable });
          });
      });
    });
  return resp;
};

const FilterSection = (props) => {
  // console.log("props.state.general",props.state.general)
  // console.log("props.state.siedco",props.state.siedco)
  // console.log("props.state.secad",props.state.secad)
  // console.log("props",props)

  return (
    <>
      <div className="filter">
        {getTags(props.state.general, props)}
        {getTags(props.state.siedco, props)}
        {getTags(props.state.secad, props)}
        {getTags(tiempo(), props)}
      </div>
      <Collapsable content={[
        // { section: 'Selección Fenomeno', content: getContent(props.state.general, props) },
        { section: 'Selección Características', content: getContent(props.state.siedco, props) },
        // { section: 'Selección Características SECAD', content: getContent(props.state.secad, props) },
        { section: 'Selección Tiempo', content: getContent(tiempo(), props) },
      ]} />
    </>
  );
};

export default FilterSection;
